<template>
  <div class="modal fade" id="ModalUserProfileEditUserList" tabindex="99" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ویرایش حساب کاربری</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <!-- عکس کاربر -->
            <img class="img-fluid imgUserProfileEdit rounded-circle shadow" v-bind:src="IUserPic" alt="user" />
            <label class="custom-file-upload d-flex justify-content-center align-items-center mt-2 h7 text-secondary"
              style="cursor: pointer;">
              <i class="fas fa-camera fa-1x-half ml-1 text-secondary"></i>
              <input type="file" id="file-selector" name="file" style="display: none" v-on:change="ShowImage"
                accept=".png,.jpg,.jpeg" />
              انتخاب فایل تصویر
            </label>
          </div>
          <!-- کادر نام کاربر -->
          <div class="position-relative">
            <input type="text" placeholder="نام کاربر" class="form-control text-center mt-1"
              v-model="UserProfileData.SUserFirstName" autocomplete="off" />
            <i class="far fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;">
              <span class="mr-1 captionField">نام</span>
            </i>
          </div>
          <!-- کادر نام خانوادگی کاربر -->
          <div class="position-relative">
            <input type="text" placeholder="نام خانوادگی کاربر" class="form-control text-center mt-1"
              v-model="UserProfileData.SUserLastName" autocomplete="off" />
            <i class="fas fa-user fa-1x-half position-absolute" style="right: 8px; top: 33%;">
              <span class="mr-1 captionField">نام خانوادگی</span>
            </i>
          </div>
          <!-- کادر تلفن همراه -->
          <div class="position-relative">
            <input type="text" placeholder="تلفن همراه" class="form-control text-center mt-1"
              v-model="UserProfileData.SMobileNo" v-on:keypress="onlyNumberAccept" autocomplete="off" style="direction: ltr;" />
            <i class="fas fa-mobile-alt fa-1x-half position-absolute" style="right: 10px; top: 33%;">
              <span class="mr-1 captionField">تلفن همراه</span>
            </i>
          </div>
          <!-- کادر کد ملی -->
          <div class="position-relative">
            <input type="text" placeholder="کد ملی" class="form-control text-center mt-1"
              v-model="UserProfileData.NPerNationalId" v-on:keypress="onlyNumberAccept" autocomplete="off"
              style="direction: ltr;" />
            <i class="far fa-address-card fa-1x-half position-absolute" style="right: 6px; top: 33%;">
              <span class="mr-1 captionField">کد ملی</span>
            </i>
          </div>
          <!-- کادر سازمان -->
          <div class="position-relative">
            <select id="selectOrg" class="form-control mt-1 text-center" v-model="UserProfileData.NOrgCode"
              v-bind:disabled="getTbBaseOrgData.length == 1">
              <option v-for="option in getTbBaseOrgData" v-bind:key="option.NCode" v-bind:value="option.NCode">
                {{ option.SDesc }}
              </option>
            </select>
            <i class="far fa-building fa-1x-half position-absolute" style="right: 9px; top: 33%;">
              <span class="mr-1 captionField">سازمان</span>
            </i>
          </div>
          <p class="h6 mt-2 text-info">تغییر رمز ورود</p>
          <input type="password" placeholder="رمز جدید" class="form-control text-center mt-1"
            v-model="UserProfileData.NewPassword" autocomplete="new-password" style="direction: ltr;" />
          <input type="password" placeholder="تکرار رمز جدید" class="form-control text-center mt-1"
            v-model="UserProfileData.ConfirmPassword" autocomplete="new-password" style="direction: ltr;" />
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center px-4">
          <a class="btn btn-info waves-effect waves-light" v-bind:class="checkConnectToServer ? 'disabled btn-pink' : ''"
            v-on:click="SaveEditProfile()">
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ذخیره تغییرات
          </a>
          <a class="btn btn-outline-info waves-effect waves-light" v-bind:class="checkConnectToServer ? 'disabled' : ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem" data-dismiss="modal">انصراف</a>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      UserProfileData: {
        NUserCode: 0,
        NPerNationalId: '',
        SUserFirstName: '',
        SUserLastName: '',
        SUserName: '',
        SMobileNo: '',
        NewPassword: '',
        ConfirmPassword: '',
        ImageFormFile: '',
        NOrgCode: 0,
        SOrgName: '',
      },
      TbBaseOrgDataLocal: [],
      IUserPic: this.$store.getters.getImageUrl + "Users/User.png",
      // کنترل وضعیت اتصال به سرور
      checkConnectToServer: false,
    };
  },
  props: ['UserData'],
  computed: {
    getTbBaseOrgData() {
      // دریافت لیست سازمان ها
      this.TbBaseOrgDataLocal = this.$store.getters.getTbBaseOrgData;
      return this.TbBaseOrgDataLocal;
    },
  },
  methods: {
    // درج فقط عدد مجاز است
    onlyNumberAccept($event) {
      this.errorText = "";
      if (!/\d/.test($event.key)) {
        return $event.preventDefault();
      }
    },
    // دریافت اطلاعات کاربر
    getUserData() {
      console.log('UserData ...', this.UserData);
      this.UserProfileData.NUserCode = this.UserData.NUserID;
      if (this.UserData.IUserPic != null && this.UserData.IUserPic != '') {
        this.IUserPic = 'data:image/png;base64,' + this.UserData.IUserPic;
      } else {
        // چون عکس کاربر ثبت نشده است
        // به صورت موقت از تصویر پیش فرض استفاده کن
        this.IUserPic = this.$store.getters.getImageUrl + "Users/User.png";
      }
      this.UserProfileData.NPerNationalId = this.UserData.NPerNationalId;
      this.UserProfileData.SUserFirstName = this.UserData.SUserFirstName;
      this.UserProfileData.SUserLastName = this.UserData.SUserLastName;
      this.UserProfileData.SUserName = this.UserData.SUserName;
      this.UserProfileData.SMobileNo = this.UserData.SMobileNo;
      this.UserProfileData.NOrgCode = this.UserData.NOrgCode;
      this.UserProfileData.SOrgName = this.UserData.SOrgName;
      this.UserProfileData.NewPassword = '';
      this.UserProfileData.ConfirmPassword = '';
      this.UserProfileData.ImageFormFile = '';
    },
    // نمایش تصویر انتخاب شده در تگ ایمیج
    ShowImage(event) {
      // فرمت های مجاز برای فایل تصویر
      var AcceptType = ['image/jpeg', 'image/jpg', 'image/png'];
      const file = event.target.files[0];
      // آیا فایلی انتخاب شده است ؟
      if (file != undefined) {
        // آیا فایل انتخابی دارای فرمت مجاز است ؟
        if (AcceptType.indexOf(file.type) != -1) {
          // آیا سایز فایل کمتر مساوی 200 کیلو بایت است؟
          if (file.size <= 204800) {
            // ذخیره نام فایل
            // this.UserProfileData.SImageName = file.name;
            // ذخیره آدرس فایل
            this.IUserPic = URL.createObjectURL(file);
            // تبدیل فایل به base64
            var reader = new FileReader();
            let base64String = "";
            reader.onloadend = function () {
              base64String = reader.result.toString().replace("data:", "")
                .replace(/^.+,/, "");
            }
            reader.readAsDataURL(file);
            // دریافت مقدار Base64
            setTimeout(() => {
              this.UserProfileData.ImageFormFile = base64String;
            }, 1000);
          } else {
            // سایز فایل انتخابی بزرگتر از 200 کیلو بایت است
            this.$store.dispatch("notify", {
              notText: "سایز فایل انتخابی بیشتر از 200 کیلو بایت است !\nشما مجاز به ارسال فایل های حجیم نیستید .\nسایز فایل انتخابی : " + parseFloat(file.size / 1024).toFixed(2) + " کیلو بایت",
              timeOut: 4500,
            });
          }
        } else {
          // نوع فایل انتخابی معتبر نمی باشد
          this.$store.dispatch("notify", {
            notText: "نوع فایل انتخابی معتبر نمی باشد !\nانواع مجاز : png / jpg / jpeg",
            timeOut: 3500,
          });
        }
      }
    },

    // ذخیره تغییرات حساب کاربری
    async SaveEditProfile() {
      this.UserProfileData.SUserName = (this.UserProfileData.SUserFirstName != "" ? this.UserProfileData.SUserFirstName + " " : "") + (this.UserProfileData.SUserLastName != "" ? this.UserProfileData.SUserLastName : "");
      // آیا نام کاربر مقدار دهی شده است ؟
      if (this.UserProfileData.SUserName != '') {
        // آیا موبایل ثبت شده است ؟
        if (this.UserProfileData.SMobileNo != '' && this.UserProfileData.SMobileNo != 0) {
          // آیا کد ملی درج شده است ؟
          if (this.UserProfileData.NPerNationalId != '' && this.UserProfileData.NPerNationalId != 0) {
            // آیا کلمه عبور درج شده است و با تکرار آن یکسان است ؟
            if (this.UserProfileData.NewPassword === '' || this.UserProfileData.NewPassword == this.UserProfileData.ConfirmPassword) {
              // اعلام اتصال به سرور
              this.checkConnectToServer = true;
              // دریافت توکن احراز هویت
              let token = await this.$store.getters.getUserData.token;
              // ویرایش اطلاعات کاربر در سرور
              var check = await this.$store.dispatch("EditUserProfile", {
                UserProfileData: this.UserProfileData,
                token: token,
              });
              if (check.Status == true) {
                // دریافت نام سازمان جهت نمایش موقت محلی
                let norgcode = this.UserProfileData.NOrgCode;
                let index = this.TbBaseOrgDataLocal.findIndex(item => item.NCode == norgcode);
                if (index != -1)
                  this.UserProfileData.SOrgName = this.TbBaseOrgDataLocal[index].SDesc;
                // بستن مودال ویرایش اطلاعات کاربر
                $("#ModalUserProfileEditUserList").modal("hide");
                // اعلام اعمال تغییرات به والد
                this.$emit("EditUser", this.UserProfileData);
              }
            } else {
              // کلمه عبور با تکرار آن یکسان نیست
              this.$store.dispatch("notify", {
                notText: "کلمه عبور با تکرار آن یکسان نیست !",
                timeOut: 2500,
              });
            }
          } else {
            // ثبت کد ملی الزامی است
            this.$store.dispatch("notify", {
              notText: "عدم درج کد ملی : درج کد ملی الزامی است !",
              timeOut: 2500,
            });
          }
        } else {
          // ثبت تلفن همراه الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج تلفن همراه : درج تلفن همراه الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت نام کاربر الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج نام : درج نام کاربر الزامی است !",
          timeOut: 2500,
        });
      }
      // اعلام اتمام اتصال به سرور
      this.checkConnectToServer = false;
    },

  },
  watch: {
    UserData: function (value) {
      this.getUserData();
    }
  }
};
</script>

<style>
.imgUserProfileEdit {
  width: 120px;
  height: 120px;
}

.captionField {
  font-family: 'VazirFD';
  font-weight: 400;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListUserInfo/Components/UserProfileEdit.vue